
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { NextPage, NextPageContext } from 'next';
import { PageProps } from 'types/pages';
import { DomainType, LOCALES, LOCALES_MAP } from 'prismic/config';
import { getDocumentRelationsFromFile } from 'prismic/getDocumentRelations';
import { fetchDocumentContent, fetchSharedData } from 'prismic/helpers/fetchContent';
import EventTemplate from 'components/templates/EventTemplate';

interface EventPageProps extends PageProps {
  data: any;
}
const Event: NextPage<EventPageProps> = ({ header, data, footer }) => {
  return <EventTemplate data={data} header={header} footer={footer} />;
};

 async function _getServerSideProps(context: NextPageContext) {
  const { domain, slug } = context.query;

  const localePrefix = context.locale;

  const currentDomain =
    (domain && (typeof domain === 'string' ? domain : domain[0])) || 'ballenberg.ch';

  const locale =
    (localePrefix && (typeof localePrefix === 'string' ? localePrefix : localePrefix[0])) ??
    LOCALES.default;
  const lang = LOCALES_MAP[locale];

  const sharedData = await fetchSharedData(lang);

  // uid can´t be empty, just for ts
  const uid = Array.isArray(slug) ? slug[slug.length - 1] : slug || '';

  const documentRelations = await getDocumentRelationsFromFile();

  const fetchedContent = await fetchDocumentContent({
    lang,
    domain: currentDomain as DomainType,
    isValidPath: true,
    uid,
    pageType: 'event_item',
  });

  if (!fetchedContent?.data) {
    console.error(`No content found ->`, {
      lang,
      domain: domain as DomainType,
      isValidPath: true,
      uid,
      pageType: 'blog_item',
    });

    return {
      notFound: true,
    };
  }

  return {
    props: {
      ...fetchedContent,
      sharedData,
      documentRelations,
    } as EventPageProps,
  };
}

export default Event;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/[domain]/events/[slug]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  